import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import "./DashboardPage.scss";
import { DesktopMenu, MobileMenu } from "shared";
import { useGetMe } from "hooks/auth";
import { useNavigate } from "react-router";
import { ROUTE_ENUM } from "enums";
const DashboardPage = () => {
  const { data: authorizedUser } = useGetMe();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!authorizedUser!.rodoAcceptedAt && authorizedUser!.role !== "admin") {
      navigate(`${ROUTE_ENUM.RODO}?uuid=${authorizedUser!.uuid}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authorizedUser]);

  return (
    <div className={`dashboard${pathname === ROUTE_ENUM.PROFILE ? " dashboard--profile" : ""}`}>
      <DesktopMenu user={authorizedUser} />
      <Outlet />
      <MobileMenu user={authorizedUser} />
    </div>
  );
};

export default DashboardPage;
